import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { TemplateFolder } from '@ps/survey-utils';

import { TemplateFolderMapper } from './mapper/template.mapper';
import { TemplateFolderPayloadMapper } from './mapper/template.payload.mapper';
import { TemplateFolderDto } from './dtos/template.dto';

export interface GetTemplatesParams {
  hasImpersonatedBuyer: boolean;
  companyId: number;
}

@Injectable({ providedIn: 'root' })
export class TemplateApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;

  public getTemplates({
    hasImpersonatedBuyer,
    companyId,
  }: GetTemplatesParams): Observable<TemplateFolder[]> {
    const params = new HttpParams({
      fromObject: {
        UI: 1,
        is_service_buyer: hasImpersonatedBuyer,
        parent_company_id: companyId,
      },
    });
    return this._http
      .get<
        TemplateFolderDto[]
      >(`${this._baseUrl}/buyers/v2/templates`, { params })
      .pipe(map((dtos) => new TemplateFolderMapper().fromDtoList(dtos)));
  }

  public createTemplateFolder(
    name: string,
    hasImpersonatedBuyer: boolean,
    parentFolderId?: number,
  ): Observable<TemplateFolder> {
    const payload = new TemplateFolderPayloadMapper().toPayload({
      name,
      hasImpersonatedBuyer,
      parentFolderId,
    });
    return this._http
      .post<TemplateFolderDto>(
        `${this._baseUrl}/buyers/v2/templates/folders`,
        payload,
      )
      .pipe(map((dto) => new TemplateFolderMapper().fromDto(dto)));
  }
}
